import React, {FC} from 'react';

import { Carousel } from 'react-responsive-carousel';
import Button from '@material-ui/core/Button';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import carouselStyles from '../../styles/Home/Carousel'; 
import img1 from '../../assets/image1.jpg';
import img2 from '../../assets/image2.jpg';
import img3 from '../../assets/image3.jpg';
import { Typography } from '@material-ui/core';

const ImagesCarousel: FC = () => {
    const classes = carouselStyles();

    const getConfigurableProps = {
        showThumbs:false,
        showStatus:false,
        autoPlay:true,
        swipeable:true,
        emulateTouch:true,
        infiniteLoop:true,
        stopOnHover:false,
        transitionTime:600,
        interval:5000
    };
    
    return(
        <React.Fragment>
            <Carousel {...getConfigurableProps}>
                <div>
                    <img src={img1} alt='Image1' className={classes.imgCarousel}/>
                    <div className={classes.infoCarousel}>
                        <Typography 
                            variant='h2' 
                            component='p' 
                            className={classes.carouselText}
                        >
                            Los mejores vinos a tu alcance
                        </Typography>
                        <Button 
                            size='large'
                            variant='contained' 
                            color='secondary' 
                            className={classes.carouselButton}
                        >
                            Comprar
                        </Button>
                    </div>
                </div>
                <div>
                    <img src={img2} alt='image2' className={classes.imgCarousel}/>
                    <div className={classes.infoCarousel}>
                        <Typography 
                            variant='h2' 
                            component='p' 
                            className={classes.carouselText}
                        >
                            Ofertas especiales cada semana
                        </Typography>
                        <Button 
                            size='large'
                            variant='contained' 
                            color='secondary' 
                            className={classes.carouselButton}
                        >
                            Ver
                        </Button>
                    </div>
                </div>
                <div>
                    <img src={img3} alt='image3' className={classes.imgCarousel}/>
                    <div className={classes.infoCarouselBottom}>
                        <Typography 
                            variant='h2' 
                            component='p' 
                            className={classes.carouselText}
                        >
                            Manejamos los mejores precios
                        </Typography>
                    </div>
                </div>
            </Carousel>
        </React.Fragment>
    )
}

export default ImagesCarousel;